// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___2Gevx","row":"row___5k2lL","full":"full___1NiEe","half":"half___2eJbK"};